module.exports = __webpack_public_path__ + "img/cloche.b0ffa279.jpeg";